import { GeneralFilterStateModel } from './general-filter.state';

export class GetAllGeneralFilterAction {
  static readonly type = '[GeneralFilter] Get All';
  constructor() {}
}

export class UpdateAllGeneralFilterAction {
  static readonly type = '[GeneralFilter] Update All GeneralFilter';
  constructor(public payload: any) {}
}

export class UpdateFilterStateAction {
  static readonly type = '[GeneralFilter] UpdateFilterState';
  constructor(public payload: Partial<GeneralFilterStateModel>) {}
}
export class UpdateSelectedFiltersAction {
  static readonly type = '[GeneralFilter] Update Selected Filters';
  constructor(
    public filterId: string,
    public selectedFilters: string[]
  ) {}
}

export class UpdateClientsFiltersAction {
  static readonly type = '[GeneralFilter] Update Clients Filters';
  constructor(
    public filterId: string,
    public selectedClient: string
  ) {}
}

export class UpdateClientIdMedidor {
  static readonly type = '[ClientId] Update Client Id';
  constructor(
    public filterId: string,
    public clientIdMedidor: number
  ) {}
}

export class ClearFilterStateAction {
  static readonly type = '[GeneralFilter] ClearFilterState';
  constructor(public filterId: string) {}
}

export class GetAllClientsFilterAction {
  static readonly type = '[GeneralFilter] Get All Clients';
  constructor(public filterId: string) {}
}

export class GetAllCityGatesFilterAction {
  static readonly type = '[GeneralFilter] Get All City Gates';
  constructor(public filterId: string) {}
}

export class UpdateSelectedGatesFilterAction {
  static readonly type = '[GeneralFilter] Update Selected Filter';
  constructor(
    public filterId: string,
    public selectedFiltersGates: string[]
  ) {}
}

export class GetIdMedidor {
  static readonly type = '[IdMedidor] Get Id Medidor';
  constructor() {}
}

export class UpdateCreg185FilterAction {
  static readonly type = '[GeneralFilter] Update Creg185';
  constructor(
    public filterId: string,
    public creg185: boolean | null
  ) {}
}

export class UpdateClientTypeFilterAction {
  static readonly type = '[GeneralFilter] Update ClientType';
  constructor(
    public filterId: string,
    public clientType: string | null
  ) {}
}
